import { Request } from 'api';
import { AxiosResponse } from 'axios';
import { Group } from 'utils';
import { PhotoMatchResult } from '../../modules/community/components/ProfilePhotoMatchReview';

interface PhotoUpload {
    s3_path: string;
    original_filename: string;
}

type ReturnType = Promise<AxiosResponse<PhotoMatchResult>>;

const uploadProfilePhotos = (group: Group, photos: PhotoUpload[]): ReturnType => {
    return Request.post(`/imports/group/members/${group.uuid}/photos`, {
        photos,
    });
};

export default uploadProfilePhotos;
